// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"pdfmake":"97d307dd2b0c835d","canvg":"2d818db0383c23ce","xlsx":"707578ee9da41e84"}[chunkId] + ".js";
};